import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './home/home.component';
import { SpaceComponent } from './space/space.component';
import { SpaceStep1Component } from './space-step-1/space-step-1.component';
import { SpaceStep2Component } from './space-step-2/space-step-2.component';
import { SpaceStep3Component } from './space-step-3/space-step-3.component';
import { SpaceStep4Component } from './space-step-4/space-step-4.component';
import { SpaceStep5Component } from './space-step-5/space-step-5.component';
import { SpaceStep6Component } from './space-step-6/space-step-6.component';
import { SpaceStep7Component } from './space-step-7/space-step-7.component';
import { SpaceStep8Component } from './space-step-8/space-step-8.component';
import { SpaceStep9Component } from './space-step-9/space-step-9.component';
import { ContactComponent } from './contact/contact.component';
import { NotifComponent } from './notif/notif.component';
import { PostComponent } from './post/post.component';
import { AdminsComponent } from './admins/admins.component';

import { AuthGuard } from './guards/auth.guard';
import { RedirectGuard } from './guards/redirect.guard';


const appRoutes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full', canActivate: [RedirectGuard] },
  { path: '', component: LayoutComponent, canActivate: [AuthGuard], children: [
  // { path: '', component: LayoutComponent, children: [
    { path: 'home', pathMatch: 'full', component: HomeComponent },
    { path: 'chantiers', component: SpaceComponent, children: [
        { path: '', pathMatch: 'full', redirectTo: 'home' },
        { path: 'new', pathMatch: 'full', component: SpaceStep1Component },
        { path: ':id/steps/1', component: SpaceStep1Component },
        { path: ':id/steps/2', component: SpaceStep2Component },
        { path: ':id/steps/3', component: SpaceStep3Component },
        { path: ':id/steps/4', component: SpaceStep4Component },
        { path: ':id/steps/5', component: SpaceStep5Component },
        { path: ':id/steps/6', component: SpaceStep6Component },
        { path: ':id/steps/7', component: SpaceStep7Component },
        { path: ':id/steps/9', component: SpaceStep9Component },
        { path: ':id/contacts', component: ContactComponent },
        { path: ':id/notifications', component: NotifComponent },
        { path: ':id/posts', component: SpaceStep8Component },
        { path: ':id/posts/new', component: PostComponent },
        { path: ':id/posts/:post', component: PostComponent },
        { path: ':id/administrateurs', component: AdminsComponent },
    ]},
  ]},
];

export const Routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts